'use client';

import { useCallback, useState } from 'react';

/**
 * Retry für Error-Boundaries (error.tsx): harter window.location.reload().
 *
 * Bis 2026-08-26 lief hier das kanonische App-Router-Muster (Soft-Recovery
 * über Router-Refresh + reset() in einer Transition; reset() allein refetcht
 * keine Server Components — Incident 2026-07-03). Dieses Muster traf aber den
 * Upstream-Bug «Rendered more hooks than during the previous render» im
 * App-Router selbst (vercel/next.js#63121/#78396, Sentry CHECKPOINT-EDU-N):
 * Recovery-Navigationen nach fehlgeschlagenen RSC-Fetches crashen im Router.
 * Der harte Reload macht den Bugpfad unerreichbar und ist aus einem
 * Fehlerzustand ohnehin der vollständigere Retry (Präzedenz: global-error.tsx).
 * isPending hält Button-Spinner und Doppelklick-Sperre bis zum Unload.
 */
export function useErrorRetry() {
  const [isPending, setIsPending] = useState(false);

  const retry = useCallback(() => {
    setIsPending(true);
    window.location.reload();
  }, []);

  return { retry, isPending };
}
